/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCrown = createReactComponent("outline", "crown", "IconCrown", [["path", { "d": "M12 6l4 6l5 -4l-2 10h-14l-2 -10l5 4z", "key": "svg-0" }]]);

export { IconCrown as default };
//# sourceMappingURL=IconCrown.mjs.map
